<template>
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-3">
                <div class="categories" v-if="Object.keys(categories).length > 1">
                    <div class="h4">Kategorien</div>
                    <ul class="unstyled d-flex flex-wrap d-lg-block">
                        <category :is-active="activeCategories.includes('all')"
                                       :category="{'title':'Alle','slug':'all'}"
                                       @statusChange="categoryChange"
                        />
                        <category v-for="category in categories" :key="category.id"
                                       :is-active="activeCategories.includes(category.slug)"
                                       :category="category"
                                       @statusChange="categoryChange"
                        />
                    </ul>
                </div>
            </div>
            <div class="col-12 col-lg-9">
                <item
                        v-for="(item,index) in filteredItems"
                        :key="item.id"
                        :categories="item.categories"
                        :title="item.title"
                        :address="item.address"
                        :url="item.url"
                        :text="item.text"
                        :logo="item.logo"
                        :index="index"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import Item from './Item.vue';
    import Category from './Category.vue';

    export default {
        data() {
            return {
                activeCategories: [],
            }
        },
        props: {
            'items': Array,
            'categories': Object
        },
        computed: {
            filteredItems() {
                return this.items.filter(items => {
                    let isActive = false;
                    if (this.activeCategories.includes('all')) {
                        return true;
                    }

                    Object.keys(items.categories).forEach(slug => {
                        if (this.activeCategories.includes(slug)) {
                            isActive = true;
                        }
                    });
                    return isActive
                });
            }
        },
        methods: {
            resetCategories() {
                this.activeCategories = ['all'];
            },
            categoryChange(category) {
                if (this.activeCategories.includes('all')) {
                    this.activeCategories = this.activeCategories.filter(item => item !== 'all');
                }

                if (category === 'all') {
                    this.resetCategories();
                    return;
                }

                if (this.activeCategories.includes(category)) {
                    this.activeCategories = this.activeCategories.filter(item => item !== category);

                    if (this.activeCategories.length > 0) {
                        return;
                    }
                    this.resetCategories();
                    return;
                }
                this.activeCategories.push(category);
            }
        },
        mounted() {
            this.resetCategories();
        },
        components: {Item, Category},
    }
</script>